export function NotificationInfoIconSvg() {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_di_9898_5618)">
        <path fillRule="evenodd" clipRule="evenodd" d="M10 15.5C6.70017 15.5 5.05025 15.5 4.02513 14.4749C3 13.4497 3 11.7998 3 8.5C3 5.20017 3 3.55025 4.02513 2.52513C5.05025 1.5 6.70017 1.5 10 1.5C13.2998 1.5 14.9497 1.5 15.9749 2.52513C17 3.55025 17 5.20017 17 8.5C17 11.7998 17 13.4497 15.9749 14.4749C14.9497 15.5 13.2998 15.5 10 15.5ZM10 12.525C10.2899 12.525 10.525 12.2899 10.525 12V7.8C10.525 7.51005 10.2899 7.275 10 7.275C9.71005 7.275 9.475 7.51005 9.475 7.8V12C9.475 12.2899 9.71005 12.525 10 12.525ZM10 5C10.3866 5 10.7 5.3134 10.7 5.7C10.7 6.0866 10.3866 6.4 10 6.4C9.6134 6.4 9.3 6.0866 9.3 5.7C9.3 5.3134 9.6134 5 10 5Z" fill="var(--p-cyan-500)" />
      </g>
      <defs>
        <filter id="filter0_di_9898_5618" x="0" y="0.5" width="20" height="20" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_9898_5618" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9898_5618" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9898_5618" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_9898_5618" />
        </filter>
      </defs>
    </svg>
  );
}
